namespace TabAurous.Sales {
    export namespace ApprovalOutPostingService {
        export const baseUrl = 'Sales/ApprovalOutPosting';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<Common.MasterTransaction>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Sales/ApprovalOutPosting/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ApprovalOutPostingService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
